import { useState, useEffect, useRef } from "react";
import Bredcrum from "../../components/bredcrum";
import { Tag } from "primereact/tag";
import { Tablescom } from "../../components/tablescomp";
import { Toast } from "primereact/toast";

import { userservices } from "../../services/userServices";
import { productservices } from "../../services/productServices";
import { supplierservices } from "../../services/supplierServices";
import { purchaseorderservices } from "../../services/purchaseorderService";
import { Titlebar, Searchbox, Label } from "../../components/fieldsComp";
import { Submissionbtn } from "../../components/buttons";
import { useNavigate,useLocation } from "react-router";
import { useSelector } from 'react-redux';
import { useFormikContext,useFormik,Field,Formik,Form,FieldArray } from 'formik';
import {profileservices} from '../../services/profileServices';
import { Dropdown } from 'primereact/dropdown';

const Editpurchaseorder = () => {
  const toast = useRef(null);
  const unitreducer = useSelector((state)=>state.unitreducer);
  const currencyreducer = useSelector((state)=>state.currencyreducer);
  const location = useLocation();
  const [combinedstate,setCombinedstate] = useState({});
  const [units,setUnits] = useState([]);
  const [currencies,setCurrencies] = useState([]);
  const [components,setComponents] = useState({});
  const [rows,setRows] = useState([]); 
  const [submitted,setSubmitted] = useState(true);
  const [supllierlist,setSupllierlist] = useState([]);
  const [shippingaddress,setShippingaddress] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [supllierlistobj,setSupllierlistobj] = useState([]);
  const [formData, setFormData] = useState({
    component: "",
    componentSkuCode: "",
    componentType: "",
    description: "",
    supplier: "",
    cost: "",
    stockLevel: "",
    freightCharges: "",
    unitOfMeasurement: "",
    superdrugSkuCode: "",
    notes: "",
    supplier_cost:""
  });

  useEffect(()=>{
    getunits();
    getsupplier();
    getcurrency();
    setComponents({
      'podate':new Date().toISOString().slice(0, 10)
    });
    console.log("location state");
    console.log(location.state);
    setCombinedstate(location.state);
    purchaseorderEdit(location.state.ponumber);
    getprofiles();
  },[]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlesubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
    productservices.createcomponent(formData).then((response)=>{
        console.log(response);
         if(response.status == 200){
            //  console.log€0
            toast.current.show({ severity: 'success', summary: 'Component', detail: 'Component created successfully' }); 
         }else{
            toast.current.show({ severity: 'error', summary: 'Component', detail: `${response.data.data}` }); 
         }   
    }).catch((error)=>{
        toast.current.show({ severity: 'error', summary: 'Component', detail: 'Error' }); 
    });


    // Handle form submission here
  };

  const getunits = () =>{
    unitreducer.then((response)=>{
        //  console.log(response);
         setUnits(response);
      }).catch((error)=>{
          
      });
  }
  const getsupplier = () =>{
    supplierservices.getbulkdata('active',1,100).then((response)=>{
      console.warn(response);
        if(response.status ==200){
            setSupllierlist(response.data.data);  
            let supplierobjdata = [];
            response.data.data.forEach((value,index)=>{
              let supplobj =  { name: value.name, code: value.id };
              supplierobjdata.push(supplobj); 
            });
            setSupllierlistobj(supplierobjdata);
        }else{
            setSupllierlist([]); 
            setSupllierlistobj([]);
        }
      }).catch((error)=>{
            setSupllierlist([]); 
            setSupllierlistobj([]);
      });
  }


  

  const displayunits = () =>{
    let temparr = [];
    units.forEach((value,index)=>{
        temparr.push(<option value={value.short_code}>{value.name}</option>)     
    });
    return temparr; 
  }
  const handleClose = () => {
    // Handle close action here
  };

  
  function displaySupplier2(){
      let supllierdata = [];
      supllierlist.forEach((value,index)=>{
        supllierdata.push(<option value={value.id}>{value.name}</option>); 
      });
      return supllierdata;
  }

  const getcurrency = () => {
    currencyreducer.then((response)=>{
      
      // console.log("currency reducer");
      // console.log(response);
        setCurrencies(response);
      }).catch((error)=>{
    });
  } 

  const displayCurrency = () => {
    let items = [];
    currencies.forEach((value,index)=>{
       items.push(<option key={index} value={value.code}>{value.name}</option>);
    })  
    return items;
  }

//   const getcomponents = (id) =>{
//        productservices.getcomponentsviasupplier(id).then((response)=>{
//             if(response.status == 200){
//                 setComponents(response.data.data);
//                 setRows(response.data.data.component);
//             }else{
//                 setComponents([]);
//                 setRows([]);
//             }
//        }).catch((error)=>{
//             setComponents([]);
//             setRows([]);
//             // console.log("error");  
//             // console.log(error);  
//        }) 
//   }

  const handleSave = (values) =>{
    setSubmitted(false);
    purchaseorderservices.editpurchaseorder(values).then((response)=>{  
      if(response.status ==200){
          setSubmitted(true);
          toast.current.show({ severity: 'success', summary: 'Component', detail: response.data.data }); 
      }else{
          setSubmitted(true);
          toast.current.show({ severity: 'error', summary: 'Component', detail: response.data.data }); 
      }
    }).catch((error)=>{
        setSubmitted(true);
        toast.current.show({ severity: 'Error', summary: 'Component', detail: 'Error' }); 
    })
  }

  const purchaseorderEdit = (ponumber) =>{
     purchaseorderservices.purchaseorderEdit(ponumber).then((response)=>{
        if(response.status == 200){
            let object2 = response.data.data; 
            setCombinedstate((prevData) =>{
                return {
                     ...prevData,
                     ...object2
                }   
            });  
            setRows(response.data.data.component);
        }else{
            //  console.log("respons data");  
            // console.log(response.data.data);     
        } 
    }).catch((error)=>{
        console.log(error);  
        // console.log(response.data.data);  
    });
  }

  const getprofiles = () =>{
        profileservices.getprofile().then((response)=>{
          if(response.status == 200){
             setShippingaddress(response.data.data.shippingaddress);
          }  
        }).catch((error)=>{
            console.log("error"); 
        })
    }
  
    const displayshipping = () =>{
       let item = [];
       shippingaddress?.forEach((value)=>{
          let shippingmerge = value.line+','+value.city+','+value.state+','+value.country;
          item.push(<option value={value.id}>{shippingmerge}</option>);  
       }) 
       return item;
    }

  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"Purchaseorder / Edit Purchase Order"} divider={false} />
      <div class="row">
        {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}

        {/* <Titlebar text={"Edit Purchase Order"} /> */}
        <div className="col-md-12 mt-3">
          <div className="card ps-3 pe-3">
            <div className="card-body card-body-style">
              <div className="row">
                <div className="container mt-4"></div>

                <Formik
                        initialValues={
                              combinedstate
                        }
                        enableReinitialize={true}
                        onSubmit={async (values) => {
                            // console.log("values data");
                            // console.log(values);
                            handleSave(values);
                            // await new Promise((r) => setTimeout(r, 500));
                            // alert(JSON.stringify(values, null, 2));
                        }}
                 >
                    {({ handleChange, setFieldValue,values }) => ( 
                 <Form>
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <label>Supplier</label>
                      {/* <Field as="select" className="form-control" disabled name="supplier_id"
                        onChange={(e) => {
                          setFieldValue('supplier_id',e.target.value);    
                          const { name, value } = e.target;
                        }}>
                        <option value="">Select Supplier</option>
                        {displaySupplier2()} 
                      
                       </Field> */}
                        <Dropdown value={supllierlistobj.find(sup => sup.code === combinedstate.supplier_id)} onChange={(e) => {
                          const { name, value } = e.target;
                          // console.log(value);
                          // getcomponents(value.code); 
                          setFieldValue('supplier_id',e.target);
                          setCombinedstate((prevData) =>{
                              return {
                                  ...prevData,
                                  supplier_id:value.code
                              }   
                          });  
                        }} options={supllierlistobj} optionLabel="name" placeholder="Select a Supplier" 
                        filter required name="supplier_id"  className="w-100" disabled />
                    </div>
                    <div className="col-md-6 form-group">
                      <label>Purchase Order Date</label>
                      <Field
                        type="date"
                        name="podate"
                        className="form-control"
                        placeholder="Select Date"
                        required
                      />
                    </div>

                    <div className="col-md-6 form-group">
                      <label>Po No.</label>
                      <Field
                        type="text"
                        name="ponumber"
                        className="form-control"
                        placeholder="Po number"
                        required
                      />
                    </div>

                    <div className="col-md-6 form-group">
                      <label><i className="fa fa-address"></i> Shipping Address</label>
                      <Field as="select"  className="form-control" name="shipping_address" required>
                             <option value="">Select Shipping Address</option>   
                             {displayshipping()}
                       </Field>
                    </div>

                    <div className="col-md-4 form-group">
                      <label>Expected Delivery Date</label>
                      <Field
                        type="date"
                        name="expecteddldate"
                        className="form-control"
                        placeholder="Expected Delivery Date"
                        required
                      />
                    </div>

                    <div className="col-md-4 form-group">
                      <label>Currency</label>
                        <Field as="select" className="form-control" name="currency">
                               {displayCurrency()}
                       </Field>
                    </div>

                    <div className="col-md-4 form-group">
                      <label>Status</label>
                      <Field
                        as="select"
                        name="status"
                        className="form-control"
                      >
                        <option value="open">Open</option> 
                        <option value="pending">Pending</option>
                        <option value="dispatched">Dispatched</option>
                        <option value="partially_received">Partially Received</option>
                        <option value="fully_received">Fully Received</option>
                        <option value="closed">Closed</option>
                      </Field>
                    </div>
                    <br/>
                   
                   <h3 className="text-success pt-3">Components : </h3>
                    {rows.map((row, index) => (
                        <div key={row.id} className="flex items-center m-1">
                            <div className='row'>

                            <div className="col-md-1 form-group">
                                 <Label name="id" />
                                
                                 <Field
                                    type="text"
                                    name={`id[${index}]`}
                                    // value={components[index].id}
                                    className="form-control"
                                    readOnly
                                 />
                            </div>

                            <div className="col-md-3 form-group">
                                 <Label name="Compoent" />
                                 <Field type="text" 
                                 name={`component[${index}]`}
                                //  value={row.component} 
                                 className="form-control" 
                                 readOnly
                                 />
                            </div>

                            <div className="col-md-2 form-group">
                                 <Label name="Sku Code" />
                                
                                 <Field type="text" 
                                 name={`componentSkuCode[${index}]`}
                                //  value={row.componentSkuCode} 
                                 className="form-control" 
                                 readOnly
                                 />
                            </div>
                            <div className="col-md-1 form-group">
                                 <Label name="Unit"/>
                                 <Field as="select" name={`unit[${index}]`} className="form-control"
                                     
                                 >
                                    <option value="">Select Unit</option>
                                    {displayunits()}
                                </Field>
                                
                            </div>
                            <div className="col-md-2 form-group">
                                 <Label name="Required Quantity" />
                                  <Field type="number" 
                                   name={`quantity[${index}]`}
                                   className="form-control"
                                    onChange={(e) => {
                                      setFieldValue(`quantity[${index}]`,e.target.value);
                                      let unitprice  = values.unitprice[index];
                                      let total_cost = (unitprice * e.target.value);
                                      setFieldValue(`totalcost[${index}]`,total_cost);
                                        // e.target.value;  
                                   }}
                                 />
                            </div>

                            <div className="col-md-1 form-group">
                                 <label>Unit price </label>
                                  <Field type="number" 
                                   name={`unitprice[${index}]`}
                                   className="form-control"
                                   step="any"
                                   onChange={(e) => {
                                      setFieldValue(`unitprice[${index}]`,e.target.value);


                                      let quantity = values.quantity[index];
                                      let total_cost = (quantity * e.target.value);
                                      setFieldValue(`totalcost[${index}]`,total_cost);
                                        // e.target.value;  
                                   }}
                                 />
                            </div>

                            <div className="col-md-2 form-group">
                                 {/* <Label name="Total cost" /> */}
                                 <label>Total cost </label>
                                  <Field type="number" 
                                   name={`totalcost[${index}]`}
                                   className="form-control" 
                                   disabled
                                 />
                            </div>

                            

                            {/* <div className="col-md-3 form-group">
                                <Label name="Select Unit"/>
                                <Field type="number" name={`quantity[${index}]`} className="form-control"
                    placeholder="Enter Quantity" required/>
                            </div>

                            <div className="col-md-3 form-group">
                                <Label name="Enter Quantity"/>  
                                <Field type="number" name={`quantity[${index}]`} className="form-control"
                    placeholder="Enter Quantity" required/>
                            </div> */}
                          </div>
                        </div>
                    ))}
                 </div>

                  <br></br>
                  <br></br>
                  <div className="row">
                    <div className="col-md-6">
                      <Submissionbtn issaved={submitted} label="Update" label2="Updating"/>
                      {/* <button
                        type="submit"
                        className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                      >
                        Save  
                     
                      </button> */}
                    </div>

                    <div className="col-md-6">
                      <button
                        type="button"
                        className="btn color-white w-100 rounded custom-btn-color-secondary"
                        onClick={handleClose}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                   </Form>
                    )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Editpurchaseorder;
